import * as yup from "yup";

export const signUpValidation = yup.object().shape({
  email: yup
    .string()
    .required("Please enter you email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    )
});

export const AccountValidation = yup.object().shape({
  accountHolderName: yup.string().required("Required"),
  accountNumber: yup
    .string()
    .matches(/^[0-9]{9,18}$/, "Invalid account number")
    .required("Required"),
  bankName: yup.string().required("Required"),
  ifscCode: yup
    .string()
    .matches(/^[A-Za-z]{4}[0-9]{7}$/, "Invalid IFSC code")
    .required("Required")
});
export const addAccountValidation = yup.object().shape({
  accountHolderName: yup.string().required("Account holder name is required"),
  bankName: yup.string().required("Required"),
  accountNumber: yup
    .string()
    .matches(/^[0-9]{9,18}$/, "Invalid account number")
    .required("Account number is required"),
  confirmAccountNumber: yup
    .string()
    .oneOf([yup.ref("accountNumber"), null], "Account number must match")
    .matches(/^[0-9]{9,18}$/, "Invalid account number")
    .required("Confirm Account number is required"),
  ifscCode: yup
    .string()
    .matches(/^[A-Za-z]{4}[A-Za-z0-9]{7}$/, "Invalid IFSC code")
    .required("Ifsc code is required")
});

export const withdrawAmountValidation = yup.object().shape({
  amount: yup
    .number()
    .required("Amount is required")
    .typeError("Amount must be a number")
    .min(1000, "Amount must be at least 1000")
    .max(1000000, "Amount must not exceed 1,000,000")
});

export const loginValidation = yup.object().shape({
  emailOrMobile: yup.string().required("Mobile number is required"),

  password: yup.string().required("Please enter password.")
});

export const forgotPasswordValidation = yup.object().shape({
  mobile: yup.string().required("Mobile number is required")

  // otp: yup.string().required('Please enter otp.'),
  // password: yup.string().required('Please enter password.'),
});
export const resetPassword = yup.object().shape({
  mobile: yup.string().required("Mobile number is required"),
  code: yup.string().required("Please enter otp."),
  newPassword: yup.string().required("Please enter new password.")
});

export const walletAddress = yup.object().shape({
  walletAddress: yup
    .string()
    .required("Please Enter Wallet Address")
    .matches(
      /^(0x)?[0-9a-fA-F]{40}$/,
      'Wallet address must be a valid hexadecimal string with or without a "0x" prefix.'
    )
});
export const walletAddressWithOtp = yup.object().shape({
  walletAddress: yup
    .string()
    .required("Please Enter Wallet Address")
    .matches(
      /^(0x)?[0-9a-fA-F]{40}$/,
      'Wallet address must be a valid hexadecimal string with or without a "0x" prefix.'
    ),
  mobileVerificationOtp: yup
    .string()
    .required("Please Enter OTP")
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
});
export const walletEmail = yup.object().shape({
  email: yup
    .string()
    .required("Please enter you email address")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Please enter valid email"
    )
});

export const nameValidation = yup.object().shape({
  firstname: yup.string().required("First name is required"),
  lastname: yup.string().required("Last name is required")
});

export const fractionManagement = yup.object().shape({
  userLevel: yup.string().required("Please Select User Level"),
  percentage: yup
    .number()
    .required("Please Enter Percentage")
    .min(1, "The number must be greater than zero")
});
